import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { TextField } from "formik-material-ui";
import InputMask from "react-input-mask";

const CPF_MASK = "***.***.***-99";
const CNPJ_MASK = "**.***.***/****-99";

const OutlineCPForCNPJ = ({ ...props }) => {
  const [newMask, setNewMask] = useState(CPF_MASK);

  const handleOnChange = (e) => {
    const { value } = e.target;
    const uppercased = value.toUpperCase();
    props.form.setFieldValue(props.field.name, uppercased);
    if (props.onChange) return props.onChange({ ...e, target: { ...e.target, value: uppercased } });
  };

  const handleMaskFormat = event => {
    const valueSize = calcValueSize(event.target.value);
    if (valueSize >= 11 || hasLetters(event.target.value)) {
      setNewMask(CNPJ_MASK);
    }
  }

  const calcValueSize = value => value.replace(/[/._-]/gi, '').length;
  const hasLetters = value => /[a-zA-Z]/.test(value);

  useEffect(() => {
    const valueSize = calcValueSize(props.value);
    if (valueSize >= 11 || hasLetters(props.value)) {
      setNewMask(CNPJ_MASK);
    } else {
      setNewMask(CPF_MASK);
    }

  }, [props.value])

  return (
    <InputMask
      mask={newMask}
      value={props.value}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      onChange={handleOnChange}
      disabled={props.disabled}
      alwaysShowMask={true}
      onKeyPress={handleMaskFormat}
    >
      <TextField
        {...props}
        style={{
          width: "100%",
          backgroundColor: props.disabled && "#eee",
        }}
        variant="outlined"
      />
    </InputMask>
  );
};

OutlineCPForCNPJ.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default OutlineCPForCNPJ;
